import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import AgGrid from '../AgGrid/AgGrid';

const AgGridPage = () => {
  const { type } = useParams();

  const { agGridReducer, attributeReducer } = useSelector((state) => ({
      agGridReducer: state.agGridReducer,
      attributeReducer: state.attributeReducer,
    })),
    { rowsList, columnSettingsList } = agGridReducer || {},
    { attributeList } = attributeReducer || {};

  return (
    <AgGrid
      type={type}
      rowsList={rowsList}
      columnSettingsList={columnSettingsList}
      filterSettings={attributeList}
    />
  );
};

export default AgGridPage;
